import { defineStore } from 'pinia'

export interface UserInfo {
  email?: string
  userName?: string
  fullName?: string
  contactEmail?: string
  mobile?: string
  authorization?: string[]
  listRole?: { code: string; [key: string]: any }[]
  rqrChangePwd?: boolean
  [key: string]: any
}

export const useAuthStore = defineStore('useAuthStore', {
  state: () => {
    return {
      auth: {
        userInfo: {} as UserInfo,
        isAuthentication: false,
        isRefreshingToken: false,
        showModalChangePassword: false,
        mqttToken: '',
        accessToken: '',
        refreshToken: '',
        memberCompanyId: '',
        memberCompanyCode: ''
      }
    }
  },
  actions: {
    setUserInfo(payload: any) {
      this.auth.userInfo = payload
    },
    setIsAuthentication(payload: boolean) {
      this.auth.isAuthentication = payload
    },
    setIsRefreshingToken(payload: boolean) {
      this.auth.isRefreshingToken = payload
    },
    setShowModalChangePassword(payload: boolean) {
      this.auth.showModalChangePassword = payload
    },
    setMqttToken(token: string) {
      this.auth.mqttToken = token
    },
    setAccessToken(token: string) {
      this.auth.accessToken = token
    },
    setRefreshToken(token: string) {
      this.auth.refreshToken = token
    },
    setMemberCompanyId(memberCompanyId: string) {
      this.auth.memberCompanyId = memberCompanyId
    },
    setMemberCompanyCode(memberCompanyCode: string) {
      this.auth.memberCompanyCode = memberCompanyCode
    }
  }
})
